import { Component, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { CommonService, Shared } from '@rubii/frontend-common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from '../../../services/config.service';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { ClientService } from '../../../services/client.service';
import { Dsps } from '@rubii/share/src/constants';


@Component({
  selector: 'app-klaviyo',
  templateUrl: './klaviyo.component.html',
  styleUrls: ['./klaviyo.component.scss']
})
export class KlaviyoComponent extends BaseDatasourceComponent implements OnInit {


  constructor(
    private client: ClientService,
    private config: ConfigService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
  }

  ngOnInit() {
    this.connectionForm = new FormGroup({
      privateKey: new FormControl('', [Validators.required])
    });
  }

  connect() {
    if (!this.connectionForm.valid) {
      this.openSnackBarWarning(this.snackBar, 'Please enter private key', 'closed');
      return;
    }
    this.client.account.saveKlaviyoConfig({id: 'abc123', privateKey: this.connectionForm.controls.privateKey.value}).then(res => {
      this.openSnackBar(this.snackBar, 'Data source connected.', 'closed');
      this.dialogRef.close();
    }).catch(e => {
      this.openSnackBarWarning(this.snackBar, e.message, 'closed');
      this.dialogRef.close();
    });
    
  }
}
